import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonService, TrackingModelService } from '@frontend/promo-homewidget';
import { UserService, ViewTemplateForClient } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { OnLoadWTDirective } from '../../../../common/web-tracking/onload-web-tracking.directive';
import { BaseLayoutComponent } from '../../common/base-layout/base-layout.component';
import { CommonEventService } from '../../common/events/common-event.service';
import { PromotionViewType } from '../../common/models/target-promotion-content';
import { TargetPromoState, targetPromoDetails } from '../../common/store/target-promotion.selectors';
import { targetPromotionDestroyed } from '../../common/store/target-promotions.actions';
import { TargetPromotionBaseComponent } from '../../common/target-promotion-base/target-promotion-base.component';
import { PlayerActivityDetails, PlayerActivityRequest } from '../models/player-activity-details';
import { loadPlayerActivityData, playerActivityDestroyed, playerActivityInit } from '../store/player-activity.actions';

@Component({
    selector: 'player-activity-page',
    templateUrl: './player-activity-page.component.html',
    imports: [BaseLayoutComponent, OnLoadWTDirective],
})
export class PlayerActivityPageComponent extends TargetPromotionBaseComponent implements OnInit, OnDestroy {
    playerActivityDetails: TargetPromoState;
    playerActivityClientContent: ViewTemplateForClient;
    playerActivityRequest: PlayerActivityRequest;
    private readonly destroy$ = new Subject();

    constructor(
        router: Router,
        store: Store<{ playerActivityModuleData: PlayerActivityDetails }>,
        trackingModelService: TrackingModelService,
        route: ActivatedRoute,
        commonEventService: CommonEventService,
        userService: UserService,
        commonService: CommonService,
    ) {
        super(router, store, trackingModelService, route, userService, commonService, commonEventService);
    }

    override ngOnInit() {
        super.ngOnInit();

        this.store.dispatch(playerActivityInit());

        this.loadPlayerActivityDetails();
        this.bindPlayerActivityDetailsData();
    }

    loadPlayerActivityDetails() {
        this.webAnalyticModel.page = PromotionViewType.PlayerActivity;
        this.commonEventService.sendWAModel(this.webAnalyticModel);
        this.playerActivityRequest = new PlayerActivityRequest(this.promoId, '', this.isAutoOptin);
        this.store.dispatch(loadPlayerActivityData(this.playerActivityRequest));
    }

    private bindPlayerActivityDetailsData() {
        this.store
            .select(targetPromoDetails)
            .pipe(takeUntil(this.destroy$))
            .subscribe((playerActivityDetails: TargetPromoState) => {
                this.playerActivityDetails = playerActivityDetails;
                if (this.isAutoOptin && this.playerActivityDetails?.metadata) {
                    this.targetPromotionMetaData = this.playerActivityDetails.metadata;
                    this.autoOptin(this.promoId);
                }
                if (this.playerActivityDetails && this.playerActivityDetails.content && this.playerActivityDetails.content.tabs) {
                    this.goToValidPromoTab(this.playerActivityDetails.content.tabs);
                }
                if (playerActivityDetails?.content && playerActivityDetails?.content?.targetPromotionCommonContent)
                    this.playerActivityClientContent = playerActivityDetails.content.targetPromotionCommonContent;
            });
    }

    override ngOnDestroy() {
        super.ngOnInit();
        this.store.dispatch(playerActivityDestroyed());
        this.store.dispatch(targetPromotionDestroyed());
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
